<template lang="pug">
  div.hdr-notification
    .card.h-50.notifications-section(v-if="haveExternalFeed(branding.externalFeedUrl)").mb-1
      .bg-white.d-flex.flex-column
        .card-header.bg-transparent.py-15
          h4.mb-0 {{ externalFeed.title }}
        .card-body.px-0.pt-0
          .pos-r.h-100
            div(v-if="externalFeed.type == 'links'")
              simplebar(data-simplebar-auto-hide="true").pin.pin-xy.of-a
                ul.list-group.list-group-flush
                  li(v-for='(item, index) in externalFeed.data' :key='item.id').list-group-item
                    .row.row-xs
                      .col-auto.text-primary
                        a(:href="item.link" target="_blank")
                          .size-42.rounded-circle.border-1x-inherit-color.d-flex
                            font-awesome-icon(:icon="item.icon" :class="item.class").fs-20.m-auto
                      .col.pr-0
                        a(:href="item.link" target="_blank").strong
                          | {{ item.title }}
                          .fs-12  {{ item.subTitle }}
                        .truncate-cell
                          .truncate.fs-12 {{ item.description }}
            div(v-if="externalFeed.type == 'single-bar-graph'")
              .fs-20.m-2.title-text {{ externalFeed.subTitle }}
              .row.row-xs
                .col-auto(:style="`color:${externalFeed.iconColor}`")
                  .size-42.ml-2.rounded-circle.border-1x-inherit-color.d-flex
                    font-awesome-icon(
                      :icon="externalFeed.icon"
                      :class="externalFeed.class"
                    ).fs-20.m-auto
                .col.pr-4
                  el-progress(
                    :show-text="externalFeed.showText == 'true'"
                    :stroke-width="26"
                    :percentage="externalFeed.delayedProgress"
                    :color="externalFeed.barColor"
                    :text-inside="externalFeed.textInside == 'true'"
                  ).my-1
                  div {{ externalFeed.progressText }}
    .card.notifications-section.notifications-wd(
      :class="branding.externalFeedUrl ? 'h-50' : 'h-100'"
    )
      .bg-white.d-flex.flex-column
        h4.mb-0.card-header.bg-transparent.py-15 Notifications
        .card-body.px-0.pt-0.fix-height
          .pos-r.h-100
            simplebar(data-simplebar-auto-hide="true").pin.pin-xy.of-a
              ul.list-group.list-group-flush
                li(
                  v-for='(item, index) in notificationArray'
                  :key='index'
                ).list-group-item
                  .row.row-xs
                    .col-auto.text-primary
                      .size-42.rounded-circle.border-1x-inherit-color.d-flex
                        font-awesome-icon(
                          v-if="item.popupType" :icon='["fal", "dollar-sign"]'
                        ).fs-20.m-auto
                        font-awesome-icon(v-else :icon='["fal", "chart-pie"]').fs-20.m-auto
                    .col.pr-0
                      .strong {{ item.userName }} {{ item.lastName }}
                      .fs-12
                        div(v-if="item.popupType") Card transaction
                        div(v-else) Additional Budget Request
                        div {{ getTime(item.requestDate) }} | {{ getDates(item.requestDate) }}
                        div(
                          v-if="item.popupType && item.recordStatus === null || item.recordStatus === 0"
                        ).text-success.fs-14 {{ item.amount | toUSD }} | PRE-AUTHORIZED
                        div(
                          v-else-if="item.popupType && item.recordStatus === 1"
                        ).text-success.fs-14 {{ item.amount | toUSD }} | CLEARED
                        div(
                          v-else-if="item.popupType && item.recordStatus === 3"
                        ).text-success.fs-14 {{ item.amount | toUSD }} | PRE-AUTHORIZED
                        div(
                          v-else-if="item.popupType && item.recordStatus === 4"
                        ).text-primary.fs-14 {{ item.amount | toUSD }} | REFUND
                        div(
                          v-else
                        ) {{ item.amount | toUSD }}, {{ item.groupName }}, {{ item.categoryName }}

                    .col-auto.px-0
                      div(v-if="item.popupType")
                        el-button(
                          v-if='item.userRole === "Manager" || item.userRole === "Admin"',
                          @click='handleViewReceipt1(item.data)' circle
                        ).border-0.p-0.size-42.mr-n2
                          font-awesome-icon(:icon='["fal", "ellipsis-v"]').fs-24.el-icon-fa
                      div(v-else)
                        el-button(
                          v-if='item.userRole === "Manager" || item.userRole === "Admin"',
                          @click='getNotificationWDG(item)' circle
                        ).border-0.p-0.size-42.mr-n2
                          font-awesome-icon(:icon='["fal", "ellipsis-v"]').fs-24.el-icon-fa
                      div(v-else='v-else')
                        el-tooltip(content='Pending' placement='top')
                          font-awesome-icon(:icon='["fal", "exclamation-triangle"]').fs-18.text-warning


    el-dialog(
      :title="this.form.categoryName"
      :visible.sync="dialogVisible"
    ).max-dialog-w-600
      template(v-if="NotificationRequests !== null && SpendNotification !== null")
        .alert.alert-info(v-if="msg")
          div {{ msg }}
        .row.align-items-center.mb-3
          .col-auto
            employee-avatar(
                :image='NotificationRequests.userPhoto'
              ).size-100px
          .col.pl-0
            .fs-18 {{ NotificationRequests.userName }}
            .fs-16 {{ NotificationRequests.email }}

        .row.align-items-center
          .col
            .row.mb-3
              .col-6
                .fs-16 Date:
                .fs-18.fw-b {{ getDates( NotificationRequests.requestDate ) }}
              .col-6
                .fs-16 Amount:
                .fs-18.fw-b {{ NotificationRequests.amount | toUSD }}
            .mb-3(v-if='NotificationRequests.note')
              .fs-16 Note:
              .fs-18.fw-b {{ NotificationRequests.note }}

        span(slot="footer" class="dialog-footer" v-if='this.budgetCheck === true')
          el-button(
            @click="declineRequest(NotificationRequests.id)"
            v-if='NotificationRequests.reqStatus !== 1 || NotificationRequests.reqStatus !== 2 || NotificationRequests.reqStatus !== 3'
          ) Decline
          el-button(
            type="primary" @click="approveRequest(NotificationRequests.id)"
            v-if='NotificationRequests.reqStatus !== 1 || NotificationRequests.reqStatus !== 2 || NotificationRequests.reqStatus !== 3'
          ) Approve
          el-button(
            @click="cancelRequest(NotificationRequests.id)"
            v-if='NotificationRequests.reqStatus !== 1 || NotificationRequests.reqStatus !== 2 || NotificationRequests.reqStatus !== 3'
          ) Remove
        span(slot="footer" class="dialog-footer" v-else='v-else')
          el-button(
            @click="declineRequest(NotificationRequests.id)"
            v-if='NotificationRequests.reqStatus !== 1 || NotificationRequests.reqStatus !== 2 || NotificationRequests.reqStatus !== 3'
          ) Decline
          el-button(
            @click="cancelRequest(NotificationRequests.id)"
            v-if='NotificationRequests.reqStatus !== 1 || NotificationRequests.reqStatus !== 2 || NotificationRequests.reqStatus !== 3'
          ) Remove

    TransactionDetail(
      :time='{time :new Date()}',
      :form = 'form',
      :fileType='fileType',
      :dialogVisible='dialogFormVisible',
      :receiptUrl = 'receiptUrl',
      @handleParentClose='handleClose($event)',
      @handleParentSubmit='submitReceipt($event)'
    )
</template>

<script>
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';
import companyBranding from '@/mixins/companyBranding';
import EmployeeAvatar from '@/components/UserAvatar.vue';
import DoughnutChart from '@/components/charts/DoughnutChart';
import TransactionDetail from '@/components/dialogs/TransactionDetail.vue';
import userExpensesMix from '@/mixins/userExpensesMix';
import userExpensePermission from '@/mixins/userExpensePermission';


export default {
  name: 'WidgetNotifications',
  components: {
    EmployeeAvatar,
    DoughnutChart,
    TransactionDetail,

  },
  mixins: [companyBranding, userExpensesMix, userExpensePermission],
  props: {
    refresh: {
      default: () => {
        // This is default
      },
      type: Object,
    },
  },
  data() {
    return {
      msg: null,
      imageUrl: '',
      file: null,
      fileType: null,
      dialogVisible: false,
      budgetCheck: true,
      catId: '',
      uploadFlag: 0,
      userIds: '',
      dialogFormVisible: false,
      form: {
        childMerchantid: '',
        merchantid: '',
        id: '',
        expenseId: '',
        qbSyncId: '',
        qbSyncStatus: '',
        categoryId: '',
        first: '',
        last: '',
        userId: '',
        title: 'Transaction Details:',
        userImage: '',
        userName: '',
        email: '',
        amount: '',
        expenseDate: '',
        merchant: '',
        status: '',
        recordStatus: 0,
        description: '',
        notes: '',
        receipt: '',
        card: '',
        isPhysical: false,
        pending: null,
        descriptionFlag: 0,
        groupId: '',
        groupName: '',
        categoryName: '',
        splitTransactions: {
          id: '',
          selectedCompany: '',
          teamId: '',
          categoryId: '',
          month: '',
          year: '',
          expenseDate: '',
          amount: '',
        },
        TransacisonTag: {
          name: '',
          id: '',
        },
        chartData: {
          allocated: 3000,
          available: 2051,
          spent: 0,
        },
      },
    };
  },
  computed: {
    ...mapGetters('Home', [
      'NotificationRequests',
      'UpdateRequest',
      'updateBalance',
      'SpendNotification',
    ]),
    ...mapGetters('notification', ['notificationArray']),
    ...mapGetters('transactions', [
      'receiptUrl',
      'categoryBudgetCalculation',
      'categoryForGroup',
      'userRoleForTeam',
      'receiptData',
    ]),
  },
  watch: {
    receiptData(value) {
      if (value) {
        if (value.error) {
          this.$message({
            message: value.error,
            type: 'error',
          });
        }
        if (value.id) {
          if (value.id !== '0') {
            this.$message({
              message: 'Transaction updated successfully.',
              type: 'success',
            });
          }
        }
        this.setLoading(false);
        this.dialogFormVisible = false;
        this.valueOfteam = '';
        this.valueOfcategory = '';
        this.imageUrl = '';
        this.file = null;
        this.form.description = '';
        this.uploadFlag = 0;
      }
      this.updateMiddleBarTeamData();
    },
  },

  methods: {
    ...mapActions('Home', [
      'getNotificationPopup',
      'updateBudgetRequest',
      'notificationSpendAmount',
      'getUpdateBalance',
    ]),
    ...mapActions('transactions', ['receiptUpload', 'getCategoryBudgetCalculation', 'getUserRoleForTeam']),
    ...mapActions('notification', ['getNotification']),
    ...mapActions('shared',['setLoading']),

    getData(value) {
      return value.reverse().slice(0, 10);
    },
    handleClose() {
      this.dialogFormVisible = false;
    },
    handleViewReceipt1(data) {
      this.handleViewReceipt(data, 'ALL TRANSACTIONS');
    },

    formatDate(value) {
      return moment(value).format('MM/DD/YYYY');
    },

    getTime(val) {
      return moment(val).format('hh:mm a');
    },
    getDates(val) {
      if (val) {
        const requestDate = moment(val).format('MM/DD/YYYY');
        const today = moment(new Date()).format('MM/DD/YYYY');
        const yesterday = moment(new Date(Date.now() - 864e5)).format('MM/DD/YYYY');

        if (requestDate === today) {
          return 'Today';
        }
        if (requestDate === yesterday) {
          return 'Yesterday';
        }
      }
      return moment(val).format('MM/DD/YYYY');
    },
    getNotificationWDG(item) {
      const {
        id, userId, categoryId, groupName, categoryName, month, year,
      } = item;
      this.catId = item.categoryId;
      this.userIds = item.userId;
      this.form.categoryName = `Additional Budget Request for ${groupName} : ${categoryName}`;
      this.form.groupName = groupName;
      const date = new Date();
      this.dialogVisible = true;
      const years = date.getFullYear();
      const months = date.getMonth() + 1;

      if (item.balanceMax > item.catBudget) {
        this.msg = 'Budget is over the category budget';
        this.budgetCheck = false;
      }

      this.getUpdateBalance({
        id: userId,
        categoryId,
        month: months,
        year: years,
      });

      this.getNotificationPopup({ id });
      this.notificationSpendAmount({
        userId,
        categoryId,
        month,
        year,
      });
    },
    approveRequest(id) {
      this.updateBudgetRequest({ id, reqStatus: 1 });
      this.getNotificationPopup({ id });
      this.dialogVisible = false;
    },
    cancelRequest(id) {
      this.updateBudgetRequest({ id, reqStatus: 3 });
      this.getNotificationPopup({ id });
      this.dialogVisible = false;
    },
    declineRequest(id) {
      this.updateBudgetRequest({ id, reqStatus: 2 });
      this.getNotificationPopup({ id });
      this.dialogVisible = false;
    },
    haveExternalFeed(url) {
      if (url && !this.fetchingExternalFeed && !this.externalFeed) {
        this.fetchingExternalFeed = true;
        fetch(url)
          .then(response => response.json())
          .then((data) => {
            this.fetchingExternalFeed = false;
            this.externalFeed = data;
            if (this.externalFeed.type === 'single-bar-graph') {
              this.externalFeed.delayedProgress = 0;
              this.$nextTick(() => {
                this.externalFeed.delayedProgress = this.externalFeed.progress / this.externalFeed.total * 100;
              });
            }
          });
      }
      return this.externalFeed;
    },
  },
};
</script>
